import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';


export interface CardValidationResponse {
  Result: number;
  ResultMessage: string;
  SponsorID: number;
  EnrollerID: number;
  CardValue: number;
  CardCurrency: string;
  CardCurrencyPrefix: string;
  CardCurrencySuffix: string;
  CardRestrictions: string;
  CardType: string;
}

export enum CardValidationApiUrls {
  ActivateCard = 'ActivateCard',
  ValidateCard = 'ValidateCard',
}

export class CardValidationDetails {
  constructor(
    public AccountNumber: string,
    public SecurityID: string,
    public EnrollerID: number,
    public CardCurrencyPrefix: string,
    public CardValue: number,
  ) {}
}

class CardActivationDetails {
  constructor(
    public AccountNumber: string,
    public SecurityID: string,
    public CustID: number
  ) {}
}

@Injectable({
  providedIn: 'root'
})

export class CardValidationService {
  giftCardApiUrl: string;
  private _cardValidationDetails: CardValidationDetails;
  private _memberId: number;

  get cardValidationDetails(): CardValidationDetails {
    return JSON.parse(localStorage.getItem('cardValidationDetails'));
  }

  set cardValidationDetails(value: CardValidationDetails) {
    this._cardValidationDetails = value;
    localStorage.setItem('cardValidationDetails', JSON.stringify(this._cardValidationDetails));
  }

  get memberId(): number {
    return JSON.parse(localStorage.getItem('memberId'));
  }

  set memberId(value: number) {
    this._memberId = value;
    localStorage.setItem('memberId', JSON.stringify(this._memberId));
  }

  constructor(private configService: ConfigService, private httpClient: HttpClient) {
    this.giftCardApiUrl = this.configService.getConfiguration().apiUrlData.giftCard;
  }

  activateCard(): Observable<any> {
    const body = new CardActivationDetails(
      this.cardValidationDetails.AccountNumber,
      this.cardValidationDetails.SecurityID,
      this.memberId,
    );
    return this.httpClient.post(this.giftCardApiUrl + CardValidationApiUrls.ActivateCard, body);
  }

  validateCard(body: { AccountNumber: string, SecurityID: string }): Observable<CardValidationResponse> {
    return this.httpClient.post<CardValidationResponse>(this.giftCardApiUrl + CardValidationApiUrls.ValidateCard, body);
  }

  removeCardValidationDetails(): void {
    localStorage.removeItem('cardValidationDetails');
    localStorage.removeItem('memberId');
    localStorage.removeItem('sourceId');
    localStorage.removeItem('cardDetailsWasPassedInUrl');
    localStorage.removeItem('cardDetailsUrl');
  }
}
